__turbopack_context__.v({
  "creditSlider": "PlasmicSliderForm-module__hs1GhW__creditSlider",
  "freeBox": "PlasmicSliderForm-module__hs1GhW__freeBox",
  "h2": "PlasmicSliderForm-module__hs1GhW__h2",
  "primaryButton__b8UxT": "PlasmicSliderForm-module__hs1GhW__primaryButton__b8UxT",
  "root": "PlasmicSliderForm-module__hs1GhW__root",
  "svg__tRDxO": "PlasmicSliderForm-module__hs1GhW__svg__tRDxO",
  "svg__xwi9W": "PlasmicSliderForm-module__hs1GhW__svg__xwi9W",
  "text__m3G49": "PlasmicSliderForm-module__hs1GhW__text__m3G49",
  "text__ww2A3": "PlasmicSliderForm-module__hs1GhW__text__ww2A3",
  "text__zwWa4": "PlasmicSliderForm-module__hs1GhW__text__zwWa4",
});
